module.exports = "/images/vendor/flag-icon-css/flags/4x3/tj.svg?a8ed5244d61deb197fad851e52e6f10b";